const getProductsQuery = (productIDs: number[], language: string) => {
  const queryBuilder = productIDs.reduce((query, productID) => {
    return `${query}
            Product_${productID}: product(id: "gid://shopify/Product/${productID}") {
                id
                title
                handle
                description
                availableForSale
                tags
                featuredImage {
                    url
                }
                priceRange {
                    minVariantPrice {
                        amount
                    }
                    maxVariantPrice {
                        amount
                    }
                }
                compareAtPriceRange {
                    minVariantPrice {
                        amount
                    }
                    maxVariantPrice {
                        amount
                    }
                }
                variants(first: 250) {
                    edges {
                        node {
                            id
                            title
                            sku
                            availableForSale
                            price {
                                amount
                                currencyCode
                            }
                            compareAtPrice {
                                amount
                            }
                            image {
                                url
                            }
                            product {
                                id
                            }
                        }
                    }
                }
            }`;
  }, '');

  return `
    query getProducts @inContext(country: ${window.Shopify?.country}, language: ${language}) {
        ${queryBuilder}
    }`;
};

export default getProductsQuery;
